var classes = {
  "card": "m_26775b0a"
};
export { classes as default };